const define = {
	data() {
		return {
			DEBUG: false,
			FEATURE: {
				IMPORT_BY_BRAND_CODE: true,
				SUM_TOTAL_IN_TABLE: false,
				MATERIAL_VENDOR_CATEGORY: true,
				IMPORT_CODE_FILE_NAME: false,
				RESEND_OTP: false,
				ON_REQUEST: true,
				REMOVE_UNSAFE_VALUE: true,
				ORGCHART_TREE_VINGROUP: false,
			},
		};
	},
};

export default define;
